module.exports = __webpack_public_path__ + "img/INTERIOR-FRONX-BOOSTERGREEN-5.22b6a776.jpg";